import type UpsellTrigger from '@alltrails/amplitude/enums/UpsellTrigger';
import { post } from '@alltrails/core/utils/post';
import type CountryCode from '@alltrails/types/CountryCode';
import type PaymentMethodType from '../types/PaymentMethodType';
import type ProResponse from '../types/ProResponse';
import type TokenizationSource from '../types/TokenizationSource';

type SubscriptionBase = {
  app_source?: string;
  apple_pay_token?: string;
  appsflyer_id?: string;
  billing_country: CountryCode;
  cc_token?: string;
  google_pay_token?: string;
  multiyear_conversion?: boolean;
  os_version?: string;
  paypal_token?: string;
  price_code: string;
  recaptcha: string;
  uid: number;
  upsell_trigger?: UpsellTrigger;
  lt14?: boolean;
  user: {
    billing_first_name?: string;
    billing_last_name?: string;
    zip?: string;
    user_entered_coupon_code?: string;
  };
};

type Subscription =
  | (SubscriptionBase & {
      payment_method_type?: never;
      token?: never;
      tokenization_source?: never;
    })
  | (SubscriptionBase & {
      payment_method_type: PaymentMethodType;
      token: string;
      tokenization_source: TokenizationSource;
    });

// see app/controllers/api/alltrails/default/purchases/subscriptions_controller.rb
export default async function createSubscription(body: Subscription) {
  return post<ProResponse>('/api/alltrails/purchases/subscriptions', body);
}
